/*<![CDATA[*/
(function () {
    const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
    
    const loadScript = () => {
        const script = document.createElement('script');
        script.async = true;
        script.src = scriptURL;
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
        script.onload = ShopifyBuyInit;
    }

    const ShopifyBuyInit = () => {
        const client = ShopifyBuy.buildClient({
            domain: 'ninyes-fi.myshopify.com',
            storefrontAccessToken: 'a890a202ffeb3f3aeef244d253fbd80a',
        });
        ShopifyBuy.UI.onReady(client).then((ui) => {
            // Get translations from data attributes
            const componentNode = document.getElementById('collection-component-1685452395944');
            const translations = {
                loadMore: componentNode.dataset.loadMore || 'Load more products',
                viewProduct: componentNode.dataset.viewProduct || 'View product',
                addToCart: componentNode.dataset.addToCart || 'Add to cart'
            };
            
            ui.createComponent('collection', {
                id: '629117583686',
                node: componentNode,
                moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
                options: {
                    "product": {
                        "styles": {
                        "product": {
                            "@media (min-width: 601px)": {
                            "max-width": "calc(25% - 20px)",
                            "margin-left": "20px",
                            "margin-bottom": "50px",
                            "width": "calc(25% - 20px)"
                            },
                            "img": {
                            "height": "calc(100% - 15px)",
                            "position": "absolute",
                            "left": "0",
                            "right": "0",
                            "top": "0"
                            },
                            "imgWrapper": {
                            "padding-top": "calc(100% + 15px)",
                            "position": "relative",
                            "height": "auto",
                            ":hover": {
                                "opacity": "0.8"
                            }
                            },
                            "compareAt": {
                            "display": "none",
                        }
                        },
                        "title": {
                            "font-family": "Figtree, sans-serif",
                            "font-weight": "normal",
                            "text-transform": "capitalize",
                            "font-size": "1rem",
                            "color": "#222222",
                            "margin-bottom": "0.4em",
                            "margin-top": "1em"
                        },
                        "button": {
                            "border-radius": "0px",
                            "background-color": "#FFF",
                            "color": "222222",
                            "border": "1px solid #222222",
                            "text-transform": "uppercase",
                            ":hover": {
                            "background-color": "#222222",
                            "color": "#FFF"
                            },
                            ":focus": {
                                "background-color": "#222222",
                                "color": "#FFF"
                            },
                        }
                        },
                        "buttonDestination": "onlineStore",
                        "contents": {
                        "button": false,
                        "options": false
                        },
                        "isButton": true,
                        "text": {
                        "button": translations.viewProduct
                        }
                    },
                    "productSet": {
                        "styles": {
                        "products": {
                            "@media (min-width: 601px)": {
                            "margin-left": "10px",
                            "margin-right": "20px"
                            }
                        }
                        },
                        "text": {
                            "nextPageButton": translations.loadMore
                        }
                    },
                    "modalProduct": {
                        "contents": {
                        "img": false,
                        "imgWithCarousel": true,
                        "button": false,
                        "buttonWithQuantity": true
                        },
                        "styles": {
                        "product": {
                            "@media (min-width: 601px)": {
                            "max-width": "100%",
                            "margin-left": "0px",
                            "margin-bottom": "0px"
                            }
                        },
                        "button": {
                            "border-radius": "7px"
                        }
                        },
                        "text": {
                        "button": translations.addToCart
                        }
                    },
                    "option": {},
                    "cart": {
                        "styles": {
                        "button": {
                            "border-radius": "7px"
                        }
                        },
                        "text": {
                        "total": "Subtotal",
                        "button": "Checkout"
                        }
                    },
                    "toggle": {}
                },
            });
        });
    }

    if (window.ShopifyBuy) {
        if (window.ShopifyBuy.UI) {
            ShopifyBuyInit();
        } else {
            loadScript();
        }
    } else {
        loadScript();
    }
})();
/*]]>*/
